var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("letter-layout", {
    attrs: {
      title: "入目无他人，四下皆是你",
      date: "2026年3月1日",
      "sign-date": "2026年3月10日",
      paragraphs: _vm.paragraphs,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }